import { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

interface NotesEditorProps {
  initialContent?: string;
  onSave?: (content: string) => void;
  setContent: any;
}

const NotesEditor = ({ initialContent = "", setContent }: NotesEditorProps) => {
  const editorRef = useRef<HTMLDivElement>(null);
  const quillRef = useRef<Quill | null>(null);

  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      [...document.querySelectorAll(`.ql-toolbar `)].map((i) => i.remove());
      const quill = new Quill(editorRef.current, {
        theme: "snow",
        bounds: editorRef.current,

        modules: {
          toolbar: [
            [{ size: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["link"],
            ["clean"],
          ],
        },
        placeholder: "Add notes here...",
      });

      if (initialContent) {
        quill.clipboard.dangerouslyPasteHTML(initialContent);
        setContent(initialContent);
      }

      quill.on("text-change", () => {
        const html = quill.root.innerHTML;
        setContent(html);
      });

      quillRef.current = quill;
    }

    return () => {
      quillRef.current = null;
      [...document.querySelectorAll(`.ql-toolbar `)][1]?.remove();
    };
  }, [editorRef]);
  return <div ref={editorRef} className={`h-[400px] w-full pb-10`}></div>;
};

export default NotesEditor;
